class Cookies {
  constructor() {
    this.banner = document.querySelector('.cookies')
    this.accept = this.banner.querySelector('.button.accept')
    this.decline = this.banner.querySelector('.button.decline')
    this.consentMode = localStorage.getItem('consentMode') 

    if (this.consentMode === null) { 
      this.showBanner()
      this.accept.addEventListener('click', this.setConsentMode.bind(this, 'granted'))
      this.decline.addEventListener('click', this.setConsentMode.bind(this, 'denied'))
    } else {
      this.hideBanner()
    }
  }
  setConsentMode(userSelection) {

    const consent = { 
      ad_storage: userSelection,
      ad_user_data: userSelection,
      ad_personalization: userSelection,
      analytics_storage: userSelection,
			personalization_storage: userSelection,
			functionality_storage: userSelection,
			security_storage: userSelection
    }

    gtag('consent', 'update', consent)

    localStorage.setItem('consentMode', JSON.stringify(consent))

    this.hideBanner()
  }
  showBanner() {
    this.banner.classList.add('visible')
  }
  hideBanner() {
    this.banner.classList.remove('visible')
  }
}

export const initCookieBanner = () => {
  new Cookies()  
}

export default () => {}